/* @sravni/react-design-system version 0.2.71 */
var COLORS = {
    GRAY: 'gray',
    GREEN: 'green',
    BLUE: 'blue',
    ORANGE: 'orange',
    VIOLET: 'violet',
    RED: 'red',
};

export { COLORS };
//# sourceMappingURL=colors.js.map
